import { callEditorApi } from 'owa-editor/lib/utils/callApi';
import { EditorViewState } from 'owa-editor';

export default function getScrollContainer(viewState: EditorViewState) {
    return callEditorApi(viewState, 'getScrollContainer');
}
